import {
  ApiService,
} from '@/internal';

export default class AdminService extends ApiService {

  index(payload = {}) {

    const {params} = payload;

    return this.request({
      method: 'get',
      url: '/admin',
      params: this.prepareParams(params),
    });
  }

  searchUsers(payload = {}) {

    const { params, ...rest } = payload;

    return this.request({
      method: 'post',
      url: '/admin/users/search',
      params: this.prepareParams(params),
      data: this.preparePayload(rest),
    });
  }

}
